// extracted by mini-css-extract-plugin
module.exports = {"root":"BasicCard_root__1g-hX","middle":"BasicCard_middle__2xenO"};